import { ComponentType } from '../../registries/types/propTypes';
import { HighlightsCProps } from '../../../components/HighlightsC/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';

export const transformHighlightsC = (data: CMSTransformerDataType): HighlightsCProps => {
  const highlightsCFeatures = Array.isArray(data?.highlights_c) ? data?.highlights_c[0] : data?.highlights_c;

  const features = highlightsCFeatures?.features?.map((feature: CMSTransformerDataType) => ({
    displayTitle: feature?.display_title,
    subTitle: feature?.sub_title,
    image: {
      url: feature?.image?.images[0]?.image?.url,
      viewport: feature?.image?.images[0]?.viewport,
      altText: feature?.image?.images[0]?.alt_text,
    },
  }));

  return {
    componentType: ComponentType.highlights_c,
    features,
  };
};

export default transformHighlightsC;
